exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.bh-avatar-upload[data-v-19abc8d6] {\r\n    display: inline-block;\n}\n.bh-emapAvatar-upload[data-v-19abc8d6] {\r\n    position: relative;\r\n    display: block;\n}\n.bh-emapAvatar-upload input[data-v-19abc8d6]{\r\n    opacity: 0;\r\n    position:absolute;\r\n    top:0;\r\n    left:0;\n}\n.avatar-buttons[data-v-19abc8d6] {\r\n    width:100%;\r\n    position: absolute;\r\n    /* bottom: 0; */\r\n    right: 0;\n}\n.avatar-button[data-v-19abc8d6] {\r\n    width:50%;\r\n    float:left;\n}\r\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-19abc8d6&scoped=true!./~/vue-loader/lib/selector.js?type=styles&index=1!./src/components/emapm-avatar-upload.vue
// module id = 162
// module chunks = 0